import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/qlogo.png"; // make sure the path is correct

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white text-center px-4">
      <img src={Logo} alt="Questa Logo" className="w-24 h-24 mb-6" />

      <h1 className="text-5xl font-extrabold text-blue-700 mb-4">404</h1>
      <p className="text-xl text-gray-700 mb-2">Oops! Page not found.</p>
      <p className="text-gray-500 mb-6">
        The page you're looking for doesn't exist or has been moved.
      </p>

      <Link
        to="/"
        className="inline-block px-6 py-3 bg-blue-700 text-white font-semibold rounded-lg shadow hover:bg-blue-800 transition"
      >
        Return to Home
      </Link>
    </div>
  );
}
